import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))

const HtmlParsingRules = lazy(() => import('.'))

class HtmlParsingRulesComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<HtmlParsingRules />
			</RootProviders>
		)
	}
}

customElements.define('html-parsing-rules', HtmlParsingRulesComponent)
